import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { store } from 'redux/store';
import { Provider } from 'react-redux';
import { registerLicense } from '@syncfusion/ej2-base';
import { msalConfig } from './authConfig';
import App from './App';
import * as serviceWorker from './serviceWorker';

const environment = process.env;
registerLicense(environment.REACT_APP_LISCENSE);

const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.render(
    <React.StrictMode>
        <MsalProvider instance={msalInstance}>
            <Provider store={store}>
                <App />
            </Provider>
        </MsalProvider>
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
